import { scooterEnumToNumStatuses } from "../../../../../data/scooter-numeric-statuses";

export const labelItems = [
  {
    label: "Hidden",
    value: scooterEnumToNumStatuses.HIDDEN,
    color: "#808080",
  },
  {
    label: "Service",
    value: scooterEnumToNumStatuses.GARAGE,
    color: "#84ff00",
  },
  {
    label: "Stolen",
    value: scooterEnumToNumStatuses.POLICE,
    color: "#ff0000",
  },
  {
    label: "Police",
    value: scooterEnumToNumStatuses.LOST,
    color: "#00c6ff",
  },
  {
    label: "Free",
    value: scooterEnumToNumStatuses.FREE,
    color: "#fff"
  },
  {
    label: "Booked",
    value: scooterEnumToNumStatuses.BOOKED,
    color: "#0000ff",
  },
  {
    label: "On ride",
    value: scooterEnumToNumStatuses.RIDING,
    color: "#008000",
  },
  {
    label: "Transfer",
    value: scooterEnumToNumStatuses.TRANSFER,
    color: "#ffd900",
  },
];

export const pausedColor = "#ffb57b";
export const stateColor = "#00FF7F";
export const technicalCheckupColor = "#84ff00";
export const brokenColor = "#0000ff";
export const lostColor = "#ff0000";



// WEBPACK FOOTER //
// ./src/views/pages/scooter/scooter/hot-map/map-filter-items.js